// 在http.js中引入axios
import axios from 'axios'; // 引入axios
import routerIndex from '@/router/index'
import errorCode from "@/store/errorCode";
import store from "@/store/index";
import dialog from '@/components/dialog/index'

// 环境的切换
if (process.env.NODE_ENV == 'development') {
  axios.defaults.baseURL = 'http://127.0.0.1:8080';
} else if (process.env.NODE_ENV == 'test') {
  axios.defaults.baseURL = '';
} else if (process.env.NODE_ENV == 'production') {
  axios.defaults.baseURL = 'http://www.etoak.com:9666';
}

//设置超时时间
axios.defaults.timeout = 10000;
//设置请求头
axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8';

// 请求拦截器
axios.interceptors.request.use(
  config => {
    // 每次发送请求之前判断是否存在token，如果存在，则统一在http请求的header都加上token，不用每次请求都手动添加了
    // 即使本地存在token，也有可能token是过期的，所以在响应拦截器中要对返回状态进行判断
    const token = store.state.token;
    token && (config.headers.Authorization = "Bearer "+token);
    return config;
  },
  error => {
    return Promise.error(error);
  })

// 响应拦截器
axios.interceptors.response.use(
  // 请求成功
  response => {
    const data = response.data;
    if(data.flag){ //成功

    }else{
      if((data.code >= 3000 && data.code <= 3099) && data.msg){
        dialog.alert(data.msg,'错误');
      }
    }
    return data;
  },
  // 请求失败
  error => {
    const { response } = error;
    if (response) {
      switch(response.status){
        case 401:
          routerIndex.push('/login');
          break;
        case 403:
          console.log("这是403");
          break;
        case 404:
          console.log("这是404");
          break;
        case 500:
          console.log("这是500");
          break;
        default:
          console.error("请求"+response.status);
      }
      return Promise.reject(response);
    } else {
      // 处理断网的情况
      if (!window.navigator.onLine) {
        //断网的情况 路由跳转到断网的页面
      }else{
        dialog.alert("服务器繁忙，请稍后重试",'错误');
      }
      return Promise.reject(error);
    }
  });

export default axios;



// WEBPACK FOOTER //
// ./src/api/http.js